import React, { HTMLProps } from "react";
import { Control } from "react-hook-form";
import { Option } from "./SelectController";

export interface ObservatoryBundleFields {
  name: string;
  description: string;
  isActive: boolean;
  observatoryReport?: Option;
  insightsReport?: Option;
  drilldown?: Option;
  marketArrayReport?: Option;
  observatoryBundlesRole: boolean;
}

export interface formContextValue {
  control?: Control<ObservatoryBundleFields>;
}

export const formContext = React.createContext<formContextValue>({});

export interface FormProps extends HTMLProps<HTMLFormElement> {
  control: Control<ObservatoryBundleFields>;
  children: React.ReactNode;
}

export const Form = (props: FormProps) => {
  return (
    <formContext.Provider value={{ control: props.control }}>
      <form {...props} noValidate>
        {props.children}
      </form>
    </formContext.Provider>
  );
};
